import { FC } from 'react'
import cn from 'classnames'
import { ListRow } from 'src/tailwind-components/extends/List'

type TProps = {
  isMobile: boolean
}

export const TableColumnHead: FC<TProps> = ({ isMobile }) =>
  isMobile ? (
    <></>
  ) : (
    <ListRow className="pointer-events-none !grid min-h-[24px] grid-cols-[40%_1fr_1fr_20px] items-center gap-5 px-4 py-3 text-label-sm font-medium text-[#6e7076] shadow-[inset_0_-1px_0_rgba(0,0,0,0.12)]">
      <div className={cn('flex min-h-[24px] items-center')}>Название</div>
      <div className={cn('flex min-h-[24px] items-center')}>ИНН</div>
      <div className={cn('flex min-h-[24px] items-center')}>КПП</div>
    </ListRow>
  )
